// extracted by mini-css-extract-plugin
export default {"success":"success_success__3D-oO","check":"success_check__KSK0E"};